export default function PreparationItemDirective() {
  return {
    template: require('./preparation-item.html'),
    scope: {
      auditId: '=',
      preparationItemCategoryId: '=',
      preparationItem: '=',
      auditIsActive: '=',
      deleteCallback: '&',
    },
    controller: 'PreparationItemController',
    controllerAs: 'preparationItemVM',
    bindToController: true,
    replace: true
  };
}
